import React from 'react';
import { createPortal } from 'react-dom';
import '../../styles/spinner.css';

function DoubleRingSpinner() {
    return (
        <div className="loadingio-spinner-double-ring-r4le9v9xha" aria-hidden="true">
            <div className="ldio-o9l06kyh74r">
                <div />
                <div />
                <div>
                    <div />
                </div>
                <div>
                    <div />
                </div>
            </div>
        </div>
    );
}

export default function LoadContentSpinner({ fullScreen = false }) {
    if (fullScreen) {
        return createPortal(
            <div className="events-page-loader" role="status" aria-live="polite" aria-label="Chargement">
                <DoubleRingSpinner />
            </div>,
            document.body
        );
    }

    return (
        <div className="events-inline-spinner-wrap" role="status" aria-label="Chargement">
            <div className="events-inline-spinner" aria-hidden="true" />
        </div>
    );
}
